import { Config } from './config';

export const config: Config = {
  variables: {
    graphBaseUrl: 'https://alanboswell-dev-api310ead3a.orangesmoke-f79e27ab.uksouth.azurecontainerapps.io/proxy',
    driveId: 'b!QNqndrwLI0iWQo1VyWzJnk5h1NGNNaZFpTPFHdpr0B3Yg5ROkfr2Tp-zf9EGhj66',
    sharedResourceFolderId: '015MSVGKXWDFAIIAB6ZRDI2WKNUZOOOHOX',
    newslettersFolderId: '015MSVGKWJ5EYBKSZWJRBLC63XNT6MDHXJ',
    sidecarManifest:
      '{"Category":{"path":"onedrive://drives/b!QNqndrwLI0iWQo1VyWzJnk5h1NGNNaZFpTPFHdpr0B3Yg5ROkfr2Tp-zf9EGhj66/items/015MSVGKXIUFSRWL3AHVELZLBMWKJPREER/content"},"Customer":{"path":"onedrive://drives/b!QNqndrwLI0iWQo1VyWzJnk5h1NGNNaZFpTPFHdpr0B3Yg5ROkfr2Tp-zf9EGhj66/items/015MSVGKWZ2CEBSTVPOJEZXXIKBZ75I7KB/content"},"Introduction":{"path":"onedrive://drives/b!QNqndrwLI0iWQo1VyWzJnk5h1NGNNaZFpTPFHdpr0B3Yg5ROkfr2Tp-zf9EGhj66/items/015MSVGKUKZDYEVD6QSFH2GYVIRX3E342L/content"},"Users":{"path":"onedrive://drives/b!QNqndrwLI0iWQo1VyWzJnk5h1NGNNaZFpTPFHdpr0B3Yg5ROkfr2Tp-zf9EGhj66/items/015MSVGKSHWOBFHXZM4RDI7S2YXHQ7SQDK/content"}}',
    appInsightsConnectionString:
      'InstrumentationKey=2f9b97bd-72dd-4dc4-9b0f-fb2a4b55727e;IngestionEndpoint=https://insights.si.services/',
    clientId: '0fb7cfc8-c408-4487-9443-13d9e6009a73',
    tenant: 'shimmerdev.onmicrosoft.com',
    authority: 'https://shimmerdev.b2clogin.com',
    apiClientId: 'c457ec6c-8c9d-43b9-808d-4c1fa9594001',
    apiScope: 'API.Access',
    policy: 'B2C_1_AB_SIGN_UP_SIGN_IN',
    supportEmail: 'james-williams@softwareimaging.com'
  },
  flags: {}
};
